import AccountantLayout from '../components/AccountantLayout';
import { AnomalyReviewContent } from '../components/accountant/AnomalyReviewContent';

export default function AccountantAnomalyReview() {
  return (
    <AccountantLayout>
      <AnomalyReviewContent />
    </AccountantLayout>
  );
}